<a [matMenuTriggerFor]="mobileMenu" class="button">
  <fa-icon [icon]="['fas', 'bars']"></fa-icon>
</a>

<mat-menu #mobileMenu="matMenu" yPosition="below" [overlapTrigger]="false" class="mobile-menu">
  <button *ngIf="account" mat-menu-item routerLink="/workshop/workbench"><fa-icon [icon]="['far', 'star']"></fa-icon> Mijn feest</button>
  <button mat-menu-item routerLink="/">Welkom</button>
  <button *ngIf="!account" mat-menu-item routerLink="/demo-onboarding">Demo</button>
  <button mat-menu-item routerLink="/how-it-works">Hoe werkt het</button>
  <button mat-menu-item routerLink="/about">Wie zijn wij</button>
  <button *ngIf="!account" mat-menu-item routerLink="/login">Log in</button>
  <a href="//help.bruiloftinjebroekzak.nl" target="_blank">
    <button mat-menu-item>Help</button>
  </a>
</mat-menu>
